import { DEFAULTS_VIEWER } from "./defaults.js";
import { HTML_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers-lazy.js";
const pluginHtml = (config) => {
  return {
    config: { ...DEFAULTS_VIEWER, ...config },
    type: HTML_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginHtml
};
//# sourceMappingURL=viewer-lazy.js.map
